var $ = jQuery;
$(document).ready(function() {

    // add to cart 
    $(document).on('submit', 'form.js-card-add-to-cart', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        var $form = $(this);
        var formData = new FormData(this);
        var id = formData.get('id');
        if (!id) return;

        var $btn = $form.find('[type="submit"]');
        $btn.prop('disabled', true).addClass('loading');

        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function() {
                var url = new URL(window.location.href);
                url.searchParams.set("open_cart", "1");
                window.location.href = url.toString();
            },
            complete: function() {
                $btn.prop('disabled', false).removeClass('loading');
            }
        });
    });


    // add to cart 

    //mega menu
    // $('.mega-menu__collection-item.has_products > a.js-mega-collection-link')
    //     .on('click', function (e) {
    //     e.preventDefault();
    //     e.stopPropagation(); 

    //     var $link = $(this);
    //     var handle = $link.data('collection');
    //     var $wrapper = $link.closest('.mega-menu__list');

    //     $wrapper
    //         .find('.js-mega-collection-link')
    //         .removeClass('is-active');

    //     $link.addClass('is-active');

    //     $wrapper
    //         .find('.mega-menu__products')
    //         .addClass('is-hidden');

    //     $wrapper
    //         .find('[data-products="' + handle + '"]')
    //         .removeClass('is-hidden');
    // });
    var $items = $('.mega-menu__collection-item');

    if (!$items.length) return;

    $items.has('ul').first().addClass('is-open');

    // click
    // $('.mega-menu__link--level-2').on('click', function(e){

    //     var $parent = $(this).closest('.mega-menu__collection-item');

    //     if(!$parent.find('ul').length){
    //     return;
    //     }
    //     e.preventDefault();

    //     $items.removeClass('is-open');
    //     $parent.addClass('is-open');
    // });
    //end mega
    // $('.header__inline-menu .mega-menu__content ul.mega-menu__list>li>a.has_sub').click(function (e) { 
    //   e.preventDefault();
    //   $('.header__inline-menu .mega-menu__content ul.mega-menu__list>li>a.has_sub').removeClass('showing');
    //   $(this).addClass('showing');
    // });
    $('.collection-category__header,.btn-readmore,button.blog-category__header,.filter-mobile').click(function(e) {
        $(this).toggleClass('is-active');
    });
    $('#verticalTitle').click(function() {
        $(this).toggleClass('active');
        $('.facets__form-vertical').toggleClass('facets__form-vertical_show');
    });
    $('form#FacetFiltersForm button.button.button--primary').click(function() {
        $('.facets__form-vertical').toggleClass('facets__form-vertical_show');
    });

    $('.footer-block.has-dropdown .footer-block__heading').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
    });
    $('.notification-close').click(function(e) {
        e.preventDefault();
        $('.notification-bar').slideUp();
    });

    function setEqualHeight() {
        var maxHeight = 0;
        $('.collection .card__heading').css('height', 'auto');

        $('.collection .card__heading').each(function() {
            var currentHeight = $(this).outerHeight();
            if (currentHeight > maxHeight) {
                maxHeight = currentHeight;
            }
        });

        $('.collection .card__heading').each(function() {
            $(this).css('height', maxHeight + 'px');
        });
    }

    $(document).ready(function() {
        setEqualHeight();
    });

    $(window).on('resize', function() {
        setEqualHeight();
    });

    ///// Tab Faq
    $(document).on('click', '.acctab_title', function(e) {
        if ($(window).width() >= 768) {
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        } else {
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
            // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }
    });
    $(document).on('click', '.acc_tab-inner .acc-tab-content .back__arrow', function(e) {
        $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
    });
    $('.acc-head').on('click', function() {
        if ($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        } else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });
    //Slider collection list
    $('.sechs_st .product-grid').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true,
        pageDots: false,
        rightToLeft: false,
        autoPlay: 4000,
        groupCells: true
    });
     $('.gallery_slider .gallery-grid').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        percentPosition: true,
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        groupCells: true
    });
    $('.has_slider .product-grid,.blog_slider .blog__posts.articles-wrapper').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        percentPosition: true,
        pageDots: true,
        rightToLeft: false,
        autoPlay: false,
        groupCells: true
    });
    //End Slider collection list
    //initFlickityMobile
    function initFlickityMobile() {
        var $lists = $(".announcement-bar .slider--everywhere,.logo_home .icon-text-wrapper,.blog_slider_mb .grid,.multi_cl_collection .grid");
        var $list_dots = $(".icons_pdp .icon-text-wrapper,.icons_jobs .icon-text-wrapper,.slide-mobile-collage");
        var $list_dots_left = $(".has_slider_mb .grid");
        if ($(window).width() < 950) {
            $lists.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: false,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 3000,
                        groupCells: false,
                        cellAlign: 'center'
                    });
                }
            });
            $list_dots.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: true,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 3000,
                        groupCells: false,
                        cellAlign: 'center'
                    });
                }
            });
            $list_dots_left.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: true,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 3000,
                        groupCells: false,
                        cellAlign: 'left'
                    });
                }
            });
        } else {
            $lists.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            $list_dots.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            $list_dots_left.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
        }
    }
    $(document).ready(initFlickityMobile);
    $(window).on('resize', initFlickityMobile);
});
var $grid = $('.middle-content_blog_right .grid');
var itemCount = $grid.find('.grid__item').length;

if (itemCount > 1) {
    $grid.flickity({
        pageDots: true,
        freeScroll: false,
        wrapAround: true,
        prevNextButtons: false,
        autoPlay: 5000,
        groupCells: false,
        cellAlign: 'center'
    });
}
/*** LOAD MORE **/
$(document).on('click', '[data-pagination-link]', function(e) {
    e.preventDefault();
    const $button = $(this);
    const nextUrl = $button.attr('href');

    $button.text("Laden...");
    $button.prop('disabled', true);

    $.get(nextUrl, function(response) {
        const $tempDiv = $('<div>').html(response);
        const newProductsHtml = $tempDiv.find('#product-grid').html();
        const $newButton = $tempDiv.find('[data-pagination-link]');

        $('ul#product-grid').append(newProductsHtml);
        $button.closest('.show_more_btn').remove(); // remove old button wrapper

        if ($newButton.length) {
            $('ul#product-grid').after($newButton.closest('.show_more_btn')); // add new button wrapper
        }
    }).fail(function() {
        console.error('Error loading more products.');
        $button.text("Try again");
        $button.prop('disabled', false);
    });
});


const params = new URLSearchParams(window.location.search);
if (params.get('open_cart') === '1') {
    const cartToggle = document.querySelector('#cart-icon-bubble');
    if (cartToggle) {
        cartToggle.click();
    }
    params.delete('open_cart');
    history.replaceState({}, '', `${location.pathname}?${params}`);
}

document.addEventListener("DOMContentLoaded", function() {
  const resetItem = document.querySelector('.reset_item');
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has('constraint')) {
    resetItem?.classList.remove('hidden');
  } else {
    resetItem?.classList.add('hidden');
  }
});



/*** MINI CART + ADD NOTE PROPERTY ***/

$(document).on("click", ".submit_form, [data-upsell-add]", function(e) {
  e.preventDefault();

  var $button = $(this);
  var isUpsell = $button.is("[data-upsell-add]");

  var variantId;
  var quantity = 1;
  var properties = {};

  var $wrapper = $button.closest(".cart-upsell-addon, form, .upsell-pro-list, .product-form");

  var $textarea = $wrapper.find("[data-upsell-message]").first();

  if (!$textarea.length) {
    $textarea = $("#CartUpsellMessage, .cart-upsell-addon__textarea").first();
  }

  var message = $textarea.length ? $.trim($textarea.val()) : "";

  if (isUpsell) {
    var $error = $wrapper.find(".cart-upsell-addon__error");

    if (!message) {
      $error.removeAttr("hidden");
      $textarea.focus();
      return;
    }

    $error.attr("hidden", true);
    variantId = Number($button.data("variant-id"));
    quantity = 1;

  } else {
    var $form = $button.closest("form");
    var $select = $form.find("select[name='id']");
    var $selectedOption = $select.find("option:selected");

    variantId = $selectedOption.val() || $button.data("pro-id") || $form.find('[name="id"]').val();
    quantity = $selectedOption.data("min-qty") || $form.find('[name="quantity"]').val() || 1;
  }

  if (message) {
    properties["Persönliche Nachricht"] = message;
  }

  $button.prop("disabled", true);

  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root + "cart/add.js",
    data: JSON.stringify({
      id: Number(variantId),
      quantity: Number(quantity),
      properties: properties
    }),
    dataType: "json",
    contentType: "application/json",
    success: function() {
       var url = new URL(window.location.href);
              url.searchParams.set("open_cart_n", "2");
              window.location.href = url.toString();

      
    },
    error: function(xhr, status, error) {
      console.error("Add to cart error:", error);
      $button.prop("disabled", false);
    }
  });
});


/*** OPEN MINI CART ***/

var minicartParams = new URLSearchParams(window.location.search);

if (minicartParams.get("open_cart_n") === "2") {
  var cartToggle = document.querySelector("#cart-icon-bubble");

  if (cartToggle) {
    cartToggle.click();
  }

  minicartParams.delete("open_cart_n");

  var newQuery = minicartParams.toString();

  history.replaceState(
    {},
    "",
    location.pathname + (newQuery ? "?" + newQuery : "")
  );
}